<template>
	<section>
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" :model="filters">
				<el-form-item>
					<el-input v-model="filters.scode" placeholder="编号" @keyup.enter.native="getLists"></el-input>
				</el-form-item>
				<el-form-item>
					<el-input v-model="filters.sname" placeholder="名称" @keyup.enter.native="getLists"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" icon="el-icon-search" @click="getLists">搜索</el-button>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="handleAdd">新增</el-button>
				</el-form-item>
			</el-form>
		</el-col>
		<!--列表-->
		<el-table :data="datalist" border stripe highlight-current-row v-loading="listLoading" style="width:90%;" height="600">
			<el-table-column prop="entime" label="时间" min-width="100"></el-table-column>
			<el-table-column prop="scode" label="编号" min-width="100"></el-table-column>
			<el-table-column prop="alisna" label="别名" min-width="60"></el-table-column>
			<el-table-column prop="sname" label="名称" min-width="100"></el-table-column>
			<el-table-column prop="remark" label="备注" min-width="100"></el-table-column>
			<el-table-column label="操作" fixed="right" width="100">
				<template slot-scope="scope">
					<div>
						<el-button type="text" size="small" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
						<el-button type="text" size="small" @click="handleDel(scope.$index, scope.row)">删除</el-button>
					</div>
				</template>
			</el-table-column>
		</el-table>
		<!--工具条翻页-->
		<el-col :span="24" class="toolbar">
		<el-pagination layout="total,prev, pager, next" @current-change="handleCurrentChange" :page-size="pagesize" :total="total" style="float:right;"></el-pagination>
		</el-col>

		<!--编辑界面-->
		<el-dialog :title="editformtitle" :visible.sync="editFormVisible" :close-on-click-modal="false">
			<el-form :model="editForm" label-width="100px" :rules="formRules" ref="editForm">
				<el-form-item label="编号" prop="scode">
					<el-input v-model="editForm.scode" placeholder="编号"></el-input>
				</el-form-item>
				<el-form-item label="名称" prop="sname">
					<el-input v-model="editForm.sname" placeholder="名称"></el-input>
				</el-form-item>
				<el-form-item label="别名" prop="alisna">
					<el-input v-model="editForm.alisna" placeholder="别名"></el-input>
				</el-form-item>
				<el-form-item label="处理类" prop="process_class">
					<el-input v-model="editForm.process_class" placeholder="处理类"></el-input>
				</el-form-item>
				<el-form-item label="拉取数据状态" class="is-required">
					<el-select v-model="editForm.valid" placeholder="请选择状态">
						<el-option label="有效" value="1"></el-option>
						<el-option label="无效" value="0"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="备注" prop="remark">
					<el-input v-model="editForm.remark" placeholder="备注" type="textarea" :row="15"></el-input>
				</el-form-item>
				<el-form-item label="token" prop="tokenstr">
					<el-input v-model="editForm.tokenstr" placeholder="token" type="textarea" :row="15"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="editFormVisible = false">取消</el-button>
				<el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
			</div>
		</el-dialog>
	</section>
</template>
<script>
	import util from '../../common/js/util'
	import { getListPage, delData, saveData } from '../../api/api';
	export default {
		data() {
			return {
				filters:{
					scode:'',sname:''
				},
				datalist: [],
				total: 0,
				pagesize:20,
				page: 1,
				listLoading: false,
				/////////////Form 表单
				editformtitle:'',//form编辑名称
				editFormVisible: false,//编辑界面是否显示
				editLoading: false,
				formRules: {
					scode :[
						{required: true,message: '编号不能为空!',trigger: 'blur'}
					],
					sname :[
						{required: true,message: '名称不能为空!',trigger: 'blur'}
					],
				},
				//编辑界面数据
				editForm: {
					actionurl:'',sqlid:'',entime:'',scode:'',sname:'',remark:'',tokenstr:'',process_class:'',valid:'2',alisna:''
				}
			}
		},
		methods: {
			getLists:function(){
				let para = {
					page: this.page,
					pagesize:this.pagesize,
					actionurl:'default/getList',
					scode:this.filters.scode,
					sname:this.filters.sname,
					sqlid:'html_spinfo.query'
				};
				this.listLoading = true;
				getListPage(para).then((res) => {
					if(!util.checkLogOut(this,res.data)){
						this.total = res.data.total;
						this.datalist = res.data.datas;
					}
					this.listLoading = false;
				});
			},
			handleCurrentChange(val) {
				this.page = val;
				this.getLists();
			},
			handleAdd:function(){
				this.editFormVisible = true;
				this.editformtitle = '新增';
				this.editForm = {
					actionurl:'default/save',sqlid:'html_spinfo.add',entime:'',scode:'',sname:'',remark:'',tokenstr:'',process_class:'',alisna:'',valid:'2'
				};
			},
			handleEdit: function (index, row) {
				this.editFormVisible = true;
				this.editformtitle = '编辑';
				this.editForm = Object.assign({}, row);
				this.editForm.actionurl = 'default/save';//设置Sqlid
				this.editForm.sqlid = 'html_spinfo.upt';
			},
			editSubmit:function(){
				let para = Object.assign({}, this.editForm);
				util.saveFunction(this,para);
			},
			handleDel: function (index, row) {
				this.$confirm('确认删除该记录吗?', '提示', {type: 'warning'}).then(() => {
					this.listLoading = true;
					let para = {
						actionurl:'default/del',
						sqlid:'html_spinfo.del',
						id:row.id
					};
					delData(para).then((res) => {
						this.listLoading = false;
						this.$message({message: res.data.message,type: res.data.type});
						this.getLists();
					});
				}).catch(() => {});
			}
		},
		mounted() {
			this.getLists();
		}
	}	
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// spInfo.vue?207ba2ea